import { Box } from '@material-ui/core';
import { Dialog } from 'src/components';
import { PDFViewer } from '@react-pdf/renderer';
import { type RootState } from 'src/store';
import { useSelector } from 'react-redux';
import QualificationsPdf from './QualificationsPdf';

interface Props {
	open: boolean;
	handleOpen: () => void;
}

function QualificationsReportDialog({ handleOpen, open }: Props) {
	const data = useSelector(
		(state: RootState) => state.courses.reports.qualifications.data,
	);

	return (
		<Dialog
			content={
				<Box display={'flex'} flexDirection={'column'} height={'100%'}>
					<Box flexGrow={1}>
						<PDFViewer
							height={'100%'}
							style={{ border: 'none' }}
							width={'100%'}
						>
							<QualificationsPdf data={data} />
						</PDFViewer>
					</Box>
				</Box>
			}
			fullScreen
			handleOpen={handleOpen}
			maxWidth={'xl'}
			noPadding
			open={open}
			title={'Reporte Calificaciones'}
		/>
	);
}

export default QualificationsReportDialog;
